import {
  DELETE_ADMIN_NOTIFICATION_TEMPLATE,
  RETRIEVE_ADMIN_NOTIFICATION_MASTER_DATA,
  EDIT_ADMIN_NOTIFICATION_TEMPLATE,
  GET_ADMIN_NOTIFICATION_TEMPLATE_INFO,
  RETRIEVE_ADMIN_NOTIFICATION_TEMPLATE_LIST,
  CREATE_ADMIN_NOTIFICATION_TEMPLATE
} from '@/api'

export default {
  retrieveAdminNotificationTemplateList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      // console.log(response);
      if (response.data.data.admin_notification_template_list.length) {
        commit('retrieveAdminNotificationTemplateList', {adminNotificationTemplateList: response.data.data.admin_notification_template_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_ADMIN_NOTIFICATION_TEMPLATE_LIST({}, successCallback, errorCallback)
  },

  createAdminNotificationTemplate({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.admin_notification_template_info) {
        // commit('retrievePlaceList', {adminNotificationTemplateList: response.data.data.place_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    CREATE_ADMIN_NOTIFICATION_TEMPLATE({data: payload.data}, successCallback, errorCallback)
  },

  editAdminNotificationTemplate({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.admin_notification_template_info) {
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    EDIT_ADMIN_NOTIFICATION_TEMPLATE({data: payload}, successCallback, errorCallback)
  },

  getAdminNotificationTemplateInfo({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.admin_notification_template_info) {
        commit('getAdminNotificationTemplateInfo', {adminNotificationTemplateInfo: response.data.data.admin_notification_template_info})
      }
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    GET_ADMIN_NOTIFICATION_TEMPLATE_INFO({payload}, successCallback, errorCallback)
  },

  deleteAdminNotificationTemplate({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      commit('deleteAdminNotificationTemplate', {adminNotificationTemplateInfo: payload})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_ADMIN_NOTIFICATION_TEMPLATE({payload}, successCallback, errorCallback)
  },

  retrieveAdminNotificationMasterData(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_ADMIN_NOTIFICATION_MASTER_DATA(successCallback, errorCallback)
  }
};
